import React, { useContext } from 'react';
import { Household as GdsHousehold } from '../../gds-api-client';
import { Confirmation, RouterContext } from '../../gs-component-right-rail';
import { Wedding, Household } from '../interfaces';
import { GdsClientContext } from '../GdsClient';
import { track } from '../helpers/analytics';

interface Props {
  onDelete: (id: string) => void;
  onClose: () => void;
  showError: () => void;
  household: Household;
  wedding: Wedding;
  analyticsObject?: object;
}

const DeleteConfirmation: React.FC<Props> = ({ household, wedding, onClose, onDelete, showError, analyticsObject }) => {
  const gdsClient = useContext(GdsClientContext);
  const { goBack } = useContext(RouterContext);

  const fireDeletionAnalytics = (): void => {
    for (let i = 0; i < household.people.length; i += 1) {
      track('Guest Deleted', {
        source: 'edit modal',
        ...analyticsObject,
      });
    }
  };

  const deleteHousehold = async (): Promise<void> => {
    if (!household) return onClose();
    try {
      await gdsClient.deleteHousehold(wedding.id, household as GdsHousehold);
      onDelete(household.id as string);
      fireDeletionAnalytics();
      onClose();
    } catch (e) {
      console.error(e);
      showError();
    }
  };

  return (
    <Confirmation
      question="Are you sure you want to delete this party?"
      primaryText="Yes, Please"
      secondaryText="No, Thanks"
      tertiaryText="Back to Party"
      onPrimaryAction={deleteHousehold}
      onSecondaryAction={goBack}
      onTertiaryAction={goBack}
    />
  );
};

export default DeleteConfirmation;
